<template>
	<v-dialog  
	 	v-model="dialog"
		:fullscreen="fullscreen"
		transition="dialog-bottom-transition"
		scrollable
		:max-width="fullscreen? null: maxWidth"
		persistent
	>
		<!-- Актіватор -->
		<template v-slot:activator="{ on: dialog, attrs }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: tooltip, attrs }">
					<slot name="activator" :attrs="attrs" :dialog="dialog" :tooltip="tooltip">
						<v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...dialog }">
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</slot>
				</template>
				<span>{{ $vuetify.lang.t(`$vuetify.${tooltip}`) | capitalize }}</span>
			</v-tooltip>
		</template>

		<v-card>
			<!-- Ttoolbar -->
			<v-toolbar flat dark color="primary" style="flex: 0 1 auto;">
				<v-avatar>
					<v-icon>{{ icon }}</v-icon>
				</v-avatar>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				
				<v-spacer></v-spacer>

				<v-btn icon @click="fullscreen = !fullscreen">
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else="fullscreen">mdi-arrow-expand</v-icon>
				</v-btn>
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>

				<template v-slot:extension>
					<v-tabs v-model="tab" align-with-title>
						<v-tabs-slider color="yellow"></v-tabs-slider>
						<v-tab v-for="item in tabs" :key="item">
							{{ item }}
						</v-tab>
					</v-tabs>

					<!-- <v-fab
						:active="tab==1"
						class="mr-4"
						icon="mdi-plus"
						location="bottom end"
						size="small"
						absolute
						offset
					></v-fab> -->
					<!-- <v-btn
						fab
						elevation="2"
						bottom
						right
						absolute
					></v-btn> -->

					<v-toolbar v-if="tab==1" dense color="transparent" flat>
						<!-- <z-field-search v-model="searchUsers"></z-field-search>
						<z-confirm-delete @ok="onRemoveUsers()" activator-type="button-icon" :disabled="users.length==0"></z-confirm-delete>
						<z-users @ok="onAddUsers($event)" activator-icon="mdi-plus" multiple :excluded="item.users"></z-users> -->
						<z-detail-price @add="addPrice">
							<template v-slot:activator="props">
								<v-btn icon v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</template>
						</z-detail-price>
					</v-toolbar>
					
					<!-- <v-toolbar v-if="tab==2" dense color="primary" elevation="0">
						<z-field-search v-model="searchServices"></z-field-search>
						<z-confirm-delete @ok="onRemoveServices()" activator-type="button-icon" :disabled="services.length==0"></z-confirm-delete>
						<z-services @ok="onAddServices($event)" activator-icon="mdi-plus" multiple :excluded="item.services"></z-services>
					</v-toolbar> -->
				</template>
			</v-toolbar>

			<v-card-text>
				<v-tabs-items v-model="tab">
					<v-tab-item class="mt-3">
						<v-form ref="form">
							<v-row>
								<v-col cols="12" md="8">
									<v-text-field
										:label="$vuetify.lang.t('$vuetify.name') | capitalize"
										v-model="item.name"
										clearable
										outlined
										dense
										hide-details="auto"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="4">
									<v-text-field
										:label="$vuetify.lang.t('$vuetify.code') | capitalize"
										v-model="item.code"
										clearable
										outlined
										dense
										hide-details="auto"
									></v-text-field>
								</v-col>
								<v-col cols="12">
									<v-textarea
										v-model="item.description"
										:label="$vuetify.lang.t('$vuetify.comment') | capitalize"
										hint=""
										rows="2"
										outlined
										dense
										hide-details="auto"
									></v-textarea>
								</v-col>

								<v-col cols="12">
									<v-combobox
										v-model="item.category"
										:items="categories"
										label="Категорія"
										outlined
										dense
										item-text="name"
										item-value="id"
										hide-details="auto"
										:loading="loadings.category"
										:rules="[rules.required, rules.onlyFromList]"
										@change="onCategory"
										@focus="focusCategory"
									></v-combobox>
								</v-col>
								<v-col cols="12" md="4">
									<v-combobox
										v-model="item.brand"
										:items="brands"
										label="Марка"
										outlined
										dense
										item-text="name"
										item-value="id"
										hide-details="auto"
										:loading="loadings.brand"
										:rules="[rules.required, rules.onlyFromList]"
										@change="onBrand"
										@focus="focusBrand"
									></v-combobox>
								</v-col>
								<v-col cols="12" md="4">
									<v-combobox
										v-model="item.model"
										:items="models"
										label="Модель"
										outlined
										dense
										item-text="name"
										item-value="id"
										hide-details="auto"
										:loading="loadings.model"
										:rules="[rules.required, rules.onlyFromList]"
										@change="onModel"
										@focus="focusModel"
									></v-combobox>
								</v-col>
								<v-col cols="12" md="4">
									<v-combobox
										v-model="item.modelYear"
										:items="years"
										label="Рік випуску"
										outlined
										dense
										hide-details="auto"
										:loading="loadings.year"
										:rules="[rules.required]"
										@focus="focusYear"
									></v-combobox>
								</v-col>
								<v-col cols="12">
									<v-select
										v-model="item.type"
										:items="types"
										label="Категорія за об'ємом двигуна"
										item-text="code"
										item-value="id"
										outlined
										dense
										hide-details="auto"
										return-object
										:loading="loadings.type"
										:rules="[rules.required, rules.onlyFromList]"
									>
										<template v-slot:item="{ on, item }">
											<v-list-item v-on="on">
												<v-list-item-content>
													<v-list-item-title>{{ item.code }}</v-list-item-title>
													<v-list-item-subtitle>{{ item.name }}</v-list-item-subtitle>
												</v-list-item-content>
											</v-list-item>
										</template>
									</v-select>
								</v-col>

								<v-col cols="12">
									<v-text-field
										label="Рейтинг"
										v-model="item.rating"
										clearable
										outlined
										dense
										hide-details="auto"
										type="Number"
										:min="0"
									></v-text-field>
								</v-col>
							</v-row>
						</v-form>
					</v-tab-item>
					<v-tab-item>
						<v-data-table
							:items="prices"
							:headers="headers"
							item-key="id"
						>
							<template v-slot:item.actions="{ item, index }">
								<v-toolbar flat dense color="transparent">
									<v-btn icon @click="removePrice(item)">
										<v-icon>mdi-delete</v-icon>
									</v-btn>
									<z-detail-price v-model="item">
										<template v-slot:activator="props">
											<v-btn icon v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
												<v-icon>mdi-pencil</v-icon>
											</v-btn>
										</template>
									</z-detail-price>
								</v-toolbar>
							</template>
							<template v-slot:[`item.date`]="{ item }">
								<span>{{ item.date | formatDate }}</span>
							</template>
							<template v-slot:[`item.value`]="{ item }">
								<span v-if="item.currency.code=='UAH'">{{ item.value | toCurrencyUAH }}</span>
								<span v-else-if="item.currency.code=='USD'">{{ item.value | toCurrencyUSD }}</span>
								<span v-else>{{ item.value | toCurrency }}</span>
							</template>
						</v-data-table>
					</v-tab-item>
				</v-tabs-items>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click.native="onCancel">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn color="success" dark @click.native="onOK" :disabled="loading">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
			</v-card-actions>
		</v-card>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-dialog>
</template>

<script>
//import axios from 'axios'
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
import zDetailPrice from '@/views/dialogs/details/CatalogVehiclePrice'

/* import zActivator from '@/views/components/activator/activator'
import zFieldSearch from '@/views/components/field.search'
import zConfirmDelete from '@/views/components/confirm-delete'
import zUsers from '@/views/dictionaries/Users'
import zServices from '@/views/dictionaries/Services' */

export default {
	name: 'DialogDetailCatalogVehicle',
	mixins: [mixin],
	components: { zDetailPrice },
	data: () => ({
		tab: null,
		tabs: ['Головна', 'Ціни'],

		headers: [
			//{ text: 'Id', value: 'id',  sortable: true },
			{ text: 'Тип', value: 'type.name', sortable: true },
			{ text: 'Ціна', value: 'value', sortable: true },
			{ text: 'Дата', value: 'date', sortable: true },
			{ text: '', value: 'actions', sortable: false, width: '10%' },
		],

		loadings: {
			category: false,
			brand: false,
			model: false,
			year: false,
			type: false,
		},
	}),

	props: {
		title: 				{ type: String, default: 'Транспортний засіб' },
		icon: 				{ type: String, default: 'mdi-car' },
		maxWidth: 			{ type: Number, default: 800 },

		category: 			{ type: Object, default: null },
		brand: 				{ type: Object, default: null },
		model: 				{ type: Object, default: null },
		modelYear: 			{ type: Number, default: null },
		type: 				{ type: Object, default: null },
	},

	computed: {
		...mapGetters('CatalogVehicle', [ 'item' ]),
		...mapGetters('VehicleCategory', { categories: 'items' }),
		...mapGetters('VehicleBrand', { brands: 'items' }),
		...mapGetters('VehicleBrandModel', { models: 'items' }),
		...mapGetters('VehicleBrandModelYear', { years: 'items' }),
		...mapGetters('VehicleInsuranceType', { insuranceTypes: 'items' }),

		id() {
			return this.item?.id ? this.item.id : null
		},

		prices() {
			return this.item?.prices ? this.item.prices : this.$set(this.item, 'prices', [])
		},

		types() {
			return this.insuranceTypes.filter((element) => ['B1','B2','B3','B4'].includes(element.code))
		},
	},

	created () {
		//console.log(this.$options.name, 'created')

		this.focusCategory()?.then(() => this.$set(this.item, 'category', this.categories[0]))
		this.focusType()?.then(() => this.$set(this.item, 'type', this.types[0]))
	},

	methods: {
		...mapActions('CatalogVehicle', [ 'find', 'create', 'update' ]),
		...mapActions('VehicleCategory', { loadCategory: 'load'}),
		...mapActions('VehicleBrand', { loadBrand: 'load', setBrands: 'setItems' }),
		...mapActions('VehicleBrandModel', { loadModel: 'load', setModels: 'setItems' }),
		...mapActions('VehicleBrandModelYear', { loadYear: 'load', setYears: 'setItems' }),
		...mapActions('VehicleInsuranceType', { loadType: 'load' }),

		clearBrand () {
			this.$set(this.item, 'brand', null)
			this.setBrands()

			this.clearModel()
		},

		clearModel () {
			this.$set(this.item, 'model', null)
			this.setModels()
		},

		clearYear () {
			this.$set(this.item, 'yearProd', null)
			this.setYears()
		},

		onCategory (item) {
			this.clearBrand()
		},

		onBrand (item) {
			this.clearModel()
		},

		onModel (item) {
			this.clearYear()
		},
		onType (item) {
			//this.clearYear()
		},

		focusCategory(e) {
			if(this.categories.length == 0) {
				this.loadings.category = true
				return this.loadCategory(this.item).finally(() => (this.loadings.category = false));
			}
		},

		focusBrand() {
			if(this.item?.category?.id && this.brands.length == 0) {
				this.loadings.brand = true
				return this.loadBrand(this.item).finally(() => (this.loadings.brand = false));
			}
		},

		focusModel() {
			if(this.item?.category?.id && this.item?.brand?.id && this.models.length == 0) {
				this.loadings.model = true
				return this.loadModel(this.item).finally(() => (this.loadings.model = false));
			}
		},

		focusYear() {
			if(this.item?.model?.id) {
				this.loadings.year = true
				return this.loadYear(this.item).finally(() => (this.loadings.year = false));
			}
		},

		focusType() {
			this.loadings.type = true
			return this.loadType(this.item).finally(() => (this.loadings.type = false));
		},

		onOpen () {
			//console.log('details.mixin.main', 'onOpen','selected', this.selected)

			if(this.selected?.id) {
				this.find(this.selected.id)
			} else {
				if(this.category) this.$set(this.item, 'category', this.category)
				if(this.brand) this.$set(this.item, 'brand', this.brand)
				if(this.model) this.$set(this.item, 'model', this.model)
				if(this.modelYear) this.$set(this.item, 'modelYear', this.modelYear)
				if(this.type) this.$set(this.item, 'type', this.type)
			}
		},

		onOK() {
			if(this.$refs.form.validate()) {
				this.loading = true

				let p = this.id ? this.update(this.selected) : this.create();

				p.then(()=>{
					this.dialog = false
				}).finally(() => {
					this.loading = false
				});
				
				/* let params = {}
				if(this.params.brand) 	params['brand'] = this.params.brand.id;
				if(this.params.brand) 	params['brand'] = this.params.brand.id;
				if(this.params.model) 	params['model'] = this.params.model.id;
				if(this.params.model) 	params['year'] = this.params.yearProd;
				if(this.params.type) 	params['type'] = this.params.type.id;

				console.log(this.$options.name, 'params', params)

				if (Object.keys(params).length > 0) {
				} */
			}
		},

		addPrice(item) {
			this.prices.push(item);
		},

		removePrice(item) {
			const index = this.prices.indexOf(item)
			this.prices.splice(index, 1);
		},

		/* onOpen (script) {
			console.log(this.$options.name, 'onOpen','item', this.item)

			this.script = script
			this.dialog = true
			this.loading = true
			let that = this
			axios.get(`/vehicle/request/${this.item.id}/averageprice/${this.script.code}/script`).then(response => {
				console.log(that.$options.name, 'onOpen','response.data', response.data)
				that.json = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => {
				this.loading = false
			});
		},

		copyText() {
			navigator.clipboard.writeText(this.$refs.script.textContent);
		} */
	},
}
</script>